import React from 'react';

const DatenschutzContent = () => {
  return (
    <div className="font-light text-gray-600 leading-relaxed">
      <h3 className="text-gray-800 font-normal mb-4">Datenschutzerklärung</h3>
      
      <section className="mb-8">
        <h4 className="text-gray-800 font-normal mb-2">Datenschutz auf einen Blick</h4>
        <p>Diese Hinweise geben einen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen oder unser Kontaktformular nutzen. Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können. Diese Website verwendet keine Cookies, keine Tracking-Dienste und keine Analyse-Tools.</p>
      </section>

      <section className="mb-8">
        <h4 className="text-gray-800 font-normal mb-2">Verantwortliche Stelle</h4>
        <p>
          Nadine Rau u. Mike Trepte GbR<br />
          Bettenhäuserstraße 1<br />
          34123 Kassel<br />
          E-Mail: mike.trepte@underopensky.de<br />
          Telefon: 0561 / 43027276
        </p>
      </section>

      <section className="mb-8">
        <h4 className="text-gray-800 font-normal mb-2">Bereitstellung der Website (Netlify / Strato)</h4>
        <p>Die Website wird über den Dienst Netlify bereitgestellt. Netlify, Inc. 2325 3rd Street, Suite 296 San Francisco, CA 94107, USA. Die Domain ist bei Strato in Deutschland registriert; die Auslieferung der Inhalte erfolgt ausschließlich über Netlify.</p>
        <p className="mt-2 text-sm text-gray-500 italic">Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse am sicheren und stabilen Betrieb).</p>
      </section>

      <section className="mb-8">
        <h4 className="text-gray-800 font-normal mb-2">Datenerfassung über das Kontaktformular (GRETA / Questera)</h4>
        <p>Für das Kontaktformular nutzen wir den Dienst GRETA, ein Produkt des US-Unternehmens Questera.ai. GRETA stellt das Formular und die technische Verarbeitung bereit, um die Daten per Webhook direkt an unser EU-basiertes System (Boost.space) zu übermitteln.</p>
      </section>

      <section className="mb-8">
        <h4 className="text-gray-800 font-normal mb-2">Zahlungsabwicklung über Stripe</h4>
        <p>Für die Bezahlung unserer Online-Seminare verwenden wir Stripe. Stripe Payments Europe, Ltd. Dublin, Irland. Stripe verarbeitet Name, E-Mail, Rechnungsinformationen und IP-Adresse.</p>
      </section>

      <section className="mb-8 border-t border-gray-100 pt-6">
        <h4 className="text-gray-800 font-normal mb-2">Ihre Rechte</h4>
        <p>Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Widerspruch gegen die Verarbeitung und Datenübertragbarkeit.</p>
        <p className="mt-4">Anfragen richten Sie an: <strong>mike.trepte@underopensky.de</strong></p>
      </section>

      <p className="text-xs text-gray-400 mt-12">Stand: Januar 2026</p>
    </div>
  );
};

export default DatenschutzContent;